import { TFiscalLocationValidationDto } from './models'

const FISCAL_LOCATION_STORAGE_KEY = 'fiscalLocation'

const getUserFiscalLocationMap = (): Record<string, TFiscalLocationValidationDto> | null => {
    if (!localStorage) return null

    return JSON.parse(localStorage.getItem(FISCAL_LOCATION_STORAGE_KEY)) as Record<
        string,
        TFiscalLocationValidationDto
    >
}

const getFiscalLocation = (username: string): TFiscalLocationValidationDto | null => {
    if (!username) return null
    const userFiscalLocationMap = getUserFiscalLocationMap()
    return userFiscalLocationMap ? userFiscalLocationMap[username] : null
}

const setFiscalLocation = (username: string, fiscalLocation: TFiscalLocationValidationDto) => {
    const currentFiscalLocationsMap = getUserFiscalLocationMap()

    localStorage.setItem(
        FISCAL_LOCATION_STORAGE_KEY,
        JSON.stringify({
            ...currentFiscalLocationsMap,
            [username]: fiscalLocation,
        }),
    )
}

export { getFiscalLocation, setFiscalLocation }
